import React from 'react'
import { useContext } from '../Context'
import { PopUpContainer } from '../../../../components/header/quick-create/PopUpContainer'
import { MenuPopUpEnum } from '../MenuPopUpEnum'
import { AddProduction } from '../../../add-workorder'

export const WorkOrderPopUp = () => {
  const { menuTarget, open, onCloseMenu } = useContext()

  return (
    <PopUpContainer show={menuTarget?.show === MenuPopUpEnum.workOrder && open} target={menuTarget?.target}>
      <AddProduction onCloseMenu={onCloseMenu} />
    </PopUpContainer>
  )
}
